<div class="dashboard-card scrollable-content card">
  <div class="card-body dashboard-card-content">
    <div class="card-title">
      <div class="d-flex justify-content-between align-items-center">
        <span class="title" translate>SALES_SUMMARY</span>
        <div class="btn-group">
          <select
            class="form-control group-on-select shadow-sm"
            [(ngModel)]="currentGroupOn"
            (change)="chooseGroup(currentGroupOn)"
          >
            <option translate [ngValue]="salesSummaryEntity.PRODUCT">PRODUCTS</option>
            <!--  <option
                  translate
                  [ngValue]="groupOn.ProductCategory"
                  >PRODUCT_CATEGORIES</option> -->
            <option translate [ngValue]="salesSummaryEntity.CUSTOMER">CUSTOMERS</option>
          </select>
          <select
            class="form-control timespan-select shadow-sm"
            [(ngModel)]="currentTimespan"
            (change)="changeTimespan(this.currentTimespan)"
          >
            <option translate [ngValue]="timespan.Week">THIS_WEEK</option>
            <option translate [ngValue]="timespan.Month">THIS_MONTH</option>
            <option translate [ngValue]="timespan.Year">THIS_YEAR</option>
            <option translate [ngValue]="timespan.LastWeek">LAST_WEEK</option>
            <option translate [ngValue]="timespan.LastMonth">LAST_MONTH</option>
            <option translate [ngValue]="timespan.LastYear">LAST_YEAR</option>
          </select>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th class="sortable" style="width: 50%" (click)="sortBy('name')">
              <i class="me-1" [ngClass]="sortIcons.name"></i>
              <span translate>NAME</span>
            </th>
            <th class="sortable text-end" style="width: 25%" (click)="sortBy('totalQuantity')">
              <div class="d-flex flex-column align-items-end">
                <div>
                  <i class="me-1" [ngClass]="sortIcons.totalQuantity"></i>
                  <span translate>PRODUCT_QUANTITY</span>
                </div>
                <div class="previous-period-header" *ngIf="showPreviousTimeSpan">({{ previousTimeSpanLabel }})</div>
              </div>
            </th>
            <th class="sortable text-end" style="width: 25%" (click)="sortBy('totalAmount')">
              <div class="d-flex flex-column align-items-end">
                <div>
                  <i class="me-1" [ngClass]="sortIcons.totalAmount"></i>
                  <span translate>TOTAL_VALUE</span>
                </div>
                <div class="previous-period-header" *ngIf="showPreviousTimeSpan">({{ previousTimeSpanLabel }})</div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let element of pagedSalesSummaryGroups">
            <td>
              <a [routerLink]="(element.entity === 'PRODUCT' ? '/product/' : '/customers/') + element.id"
                ><span class="group-name text-primary">{{ element.name }}</span></a
              >
              <br />
              <span class="group-id text-secondary">{{ element.id }} </span>
              <span
                class="open-details text-primary"
                *ngIf="element.entity === 'PRODUCT' && allowProductDetails"
                (click)="seeDetails(element)"
                >(<span translate>PRODUCT_DETAILS</span>)</span
              >
              <div class="details" *ngIf="showDetails[element.id]">
                <div class="float-left mr-2">
                  <img
                    class="card-img-top img-fluid mx-auto d-block"
                    *ngIf="showDetails[element.id].img; else noimage"
                    src="https://cdn1.gung.io/fit-in/50x50/filters:fill(white):background_color(white):format(jpeg)/{{
                      details[element.id].img
                    }}"
                  />
                  <ng-template #noimage>
                    <img
                      class="card-img-top img-fluid w-100"
                      src="https://cdn1.gung.io/fit-in/50x50/images/no-image.jpg"
                      alt="NO IMAGE"
                      class="img-fluid mx-auto d-block"
                    />
                  </ng-template>
                </div>
                <span class="b">Color: </span><span translate>{{ details[element.id].color }}</span
                ><br />
                <span class="b">Size: </span><span translate>{{ details[element.id].size }}</span>
              </div>
            </td>
            <td class="text-end">
              {{ element.totalQuantity | number: '1.0-0' }}
              <div class="previous-period-values text-end" *ngIf="showPreviousTimeSpan">
                ({{ previousTimespanSalesSummaryGroups[element.id].totalQuantity | number: '1.0-0' }})
              </div>
            </td>
            <td class="text-end">
              {{ element.totalAmount | number: '1.0-0' }}
              <div class="previous-period-values text-end" *ngIf="showPreviousTimeSpan">
                ({{ previousTimespanSalesSummaryGroups[element.id].totalAmount | number: '1.0-0' }})
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="paginator-bar d-flex justify-content-end align-items-center mt-2" *ngIf="collectionSize > 0">
      <span class="items-per-page">Items per page: {{ pageSize }}</span>
      <span class="range-label">{{ pageRangeLabel }}</span>
      <button type="button" class="btn btn-sm btn-icon" [disabled]="page === 1" (click)="goToPreviousPage()">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <button type="button" class="btn btn-sm btn-icon" [disabled]="page === totalPages" (click)="goToNextPage()">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  </div>
</div>
